export const CHECK_IF_ONLINE = 'CHECK_IF_ONLINE';

interface CheckIfOnlineAction {
	type: typeof CHECK_IF_ONLINE;
}

export type IsOnlineActionTypes = CheckIfOnlineAction;
